import PaymentType from './paymentType.js';

const LuhnCheck = (function () {
  const publicMethods = {
    simpleLuhnCheck(str) {
      let rv = false;

      const luhnArr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];

      // if the length is zero, that means the string only contains digits, dashes or spaces
      if (String(str).replace(/[\d\-\s]/g, '').length === 0) {
        // copy and modify from http://rosettacode.org/wiki/Luhn_test_of_credit_card_numbers
        let counter = 0;
        let incNum;
        let odd = false;
        const temp = String(str).replace(/[^\d]/g, '');

        // change from checking temp.length == 0  (we need at least 13 numbers)
        if (temp.length >= 13) {
          for (let i = temp.length - 1; i >= 0; --i) {
            incNum = parseInt(temp.charAt(i), 10);
            odd = !odd;
            counter += odd ? incNum : luhnArr[incNum];
          }
          rv = counter % 10 === 0;
        }
      }

      return rv;
    },

    useLuhn(cardType) {
      let rv = true;
      switch (cardType) {
        case PaymentType.AEON:
        case PaymentType.PROV:
        case PaymentType.WIRE:
        case PaymentType.COD:
        case PaymentType.PROPAY:
        case PaymentType.ISRA:
        case PaymentType.ARGE:
        case PaymentType.LCAB:
        case PaymentType.ITAL:
        case PaymentType.TARJ:
        case PaymentType.TARS:
        case PaymentType.CUP:
        case PaymentType.ALIP:
        case PaymentType.IDEA:
        case PaymentType.VIB_WIRE:
        case PaymentType.ACB_WIRE:
        case PaymentType.VCB_WIRE:
        case PaymentType.AGRIBANK_WIRE:
        case PaymentType.CR:
        case PaymentType.MAS:
        case PaymentType.PWEB:
        case PaymentType.DBS:
        case PaymentType.UOB:
        case PaymentType.MBB:
        case PaymentType.PBB:
        case PaymentType.CIMB:
        case PaymentType.KBANK:
        case PaymentType.BDO:
        case PaymentType.APVN:
        case PaymentType.KLIK:
        case PaymentType.PERMATA:
        case PaymentType.SDD:
          rv = false;
          break;
      }

      return rv;
    },

    isCardNumberMatchingType(cardNumber, cardType) {
      // assuming everything is true (even with cardNumber does not contain any digit)
      let rv = true;

      const temp = String(cardNumber).replace(/[^\d]/g, '');
      if (temp.length > 0) {
        switch (cardType) {
          case 0: // VISA
            rv = temp.startsWith('4');
            break;
          case 1: // MC
            rv = temp.startsWith('5') || temp.startsWith('2');
            break;
          case 2: // DISCOVER
            rv =
              temp.startsWith('300') ||
              temp.startsWith('301') ||
              temp.startsWith('302') ||
              temp.startsWith('303') ||
              temp.startsWith('304') ||
              temp.startsWith('305') ||
              temp.startsWith('309') ||
              temp.startsWith('352') ||
              temp.startsWith('353') ||
              temp.startsWith('354') ||
              temp.startsWith('355') ||
              temp.startsWith('356') ||
              temp.startsWith('357') ||
              temp.startsWith('358') ||
              temp.startsWith('36') ||
              temp.startsWith('38') ||
              temp.startsWith('39') ||
              temp.startsWith('6011') ||
              temp.startsWith('622') ||
              temp.startsWith('624') ||
              temp.startsWith('625') ||
              temp.startsWith('626') ||
              temp.startsWith('628') ||
              temp.startsWith('644') ||
              temp.startsWith('645') ||
              temp.startsWith('646') ||
              temp.startsWith('647') ||
              temp.startsWith('648') ||
              temp.startsWith('649') ||
              temp.startsWith('65');
            break;
          case 3: // AE
            rv = temp.startsWith('33') || temp.startsWith('37');
            break;
          case 11: // GCC
          case 12: // NCC
            rv = temp.startsWith('627531');
            break;
          case 15: // ISRA
            rv = temp.length === 7;
            break;
          case 21: // JCB
            rv = !!temp.match(/^35[\d]{14}$/);
            break;
          case 98: // CEDYNA
            rv = !!temp.match(/^97880[\d]{10}$/);
            break;
          case 108: // BCA
            rv = temp.startsWith('4') || temp.startsWith('5');
            break;
        }
      }

      return rv;
    },

    luhnCheck(cardNumber, cardType) {
      let retVal = true;

      if (cardType === undefined || cardType == null) {
        retVal = this.simpleLuhnCheck(cardNumber);
      } else if (cardType === PaymentType.CEDN) {
        retVal = this.isCardNumberMatchingType(cardNumber, cardType);
      } else if (this.useLuhn(cardType)) {
        retVal =
          this.isCardNumberMatchingType(cardNumber, cardType) &&
          this.simpleLuhnCheck(cardNumber);
      }

      return retVal;
    },
  };

  return publicMethods;
})();

export default LuhnCheck;
